"use client";

import { c as _c } from "react/compiler-runtime";
import { IconTrashOutline18 } from "nucleo-ui-outline-18";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { VARIABLE_ATTR } from "./variable-textarea-utils";
interface VariablePillPopoverProps {
  pill: HTMLElement | null;
  onDelete: () => void;
  onClose: () => void;
}
const VIEWPORT_PADDING = 8;
export function VariablePillPopover(t0) {
  const $ = _c(26);
  const {
    pill,
    onDelete,
    onClose
  } = t0;
  const popoverRef = useRef(null);
  const [position, setPosition] = useState(null);
  let t1;
  let t2;
  if ($[0] !== pill) {
    t1 = () => {
      if (!pill) {
        return;
      }
      requestAnimationFrame(() => {
        const rect = pill.getBoundingClientRect();
        const popover = popoverRef.current;
        const popoverWidth = popover?.offsetWidth ?? 0;
        let left = rect.left + rect.width / 2 - popoverWidth / 2;
        left = Math.max(VIEWPORT_PADDING, Math.min(left, window.innerWidth - popoverWidth - VIEWPORT_PADDING));
        setPosition({
          top: rect.top - 4,
          left
        });
      });
    };
    t2 = [pill];
    $[0] = pill;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== onClose) {
    t3 = () => {
      const handleKeyDown = e => {
        if (e.key === "Escape") {
          onClose();
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    };
    t4 = [onClose];
    $[3] = onClose;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[6] !== onClose) {
    t5 = () => {
      const handleClick = e_0 => {
        if (popoverRef.current && !popoverRef.current.contains(e_0.target as Node)) {
          onClose();
        }
      };
      const timer = setTimeout(() => {
        document.addEventListener("mousedown", handleClick);
      }, 0);
      return () => {
        clearTimeout(timer);
        document.removeEventListener("mousedown", handleClick);
      };
    };
    t6 = [onClose];
    $[6] = onClose;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  if (!pill) {
    return null;
  }
  let t7;
  if ($[9] !== pill) {
    t7 = pill.getAttribute(VARIABLE_ATTR) || "";
    $[9] = pill;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const variablePath = t7;
  let t8;
  if ($[11] !== position) {
    t8 = position ? {
      top: position.top,
      left: position.left
    } : {
      top: -9999,
      left: -9999
    };
    $[11] = position;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== variablePath) {
    t9 = <code className="text-ds-text-subtle max-w-[240px] truncate text-xs">{variablePath}</code>;
    $[13] = variablePath;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== onDelete) {
    t10 = e_1 => {
      e_1.preventDefault();
      e_1.stopPropagation();
      onDelete();
    };
    $[15] = onDelete;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <IconTrashOutline18 className="h-3 w-3" />;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10) {
    t12 = <button type="button" onClick={t10} className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium text-red-600 transition-colors hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-950/30">{t11}Remove</button>;
    $[18] = t10;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t9) {
    t13 = <div className="border-ds-border-default bg-ds-surface-card shadow-ds-elev-2 flex items-center gap-2 rounded-lg border px-3 py-2">{t9}{t12}</div>;
    $[20] = t12;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13 || $[24] !== t8) {
    t14 = createPortal(<div ref={popoverRef} className="fixed z-[9999] flex -translate-y-full flex-col items-center gap-1" style={t8}>{t13}</div>, document.body);
    $[23] = t13;
    $[24] = t8;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
}